export const TEXTURE_FORMAT = {
  P8: 0x00,
  RGBA7: 0x01,
  RGB16: 0x02,
  DXT1: 0x03,
  RGB8: 0x04,
  RGBA8: 0x05,
  MAX: 0xff,
} as const;
